import { render, staticRenderFns } from "./SystemSettingsPolicyBlacklistDomainEmail.vue?vue&type=template&id=6c373350"
import script from "@/scripts/modal/systemSettingsPolicyBlacklistDomainEmail.js?vue&type=script&lang=js&external"
export * from "@/scripts/modal/systemSettingsPolicyBlacklistDomainEmail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports